import { action, computed, flow, makeObservable, observable } from 'mobx';
import { GlobalStore } from '@roc/feature-app-core';
import { LoanStore } from '@roc/feature-loans';
// Assuming CogsService is a synchronous dependency
import { CogsService } from '../../../services/cogsService';

export class CogsStore {
  loanStore: LoanStore;
  globalStore: GlobalStore;
  cogsService: CogsService;

  isCogsOnline: boolean = false;
  isCogsLoading: boolean = false;

  constructor(
    loanStore: LoanStore,
    globalStore: GlobalStore
  ) {

    this.globalStore = globalStore;
    this.loanStore = loanStore;
    this.cogsService = new CogsService();

    makeObservable(this, {
      isCogsOnline: observable,
      isCogsLoading: observable,
      fetchIsCogsOnline: flow
    });
  }

  fetchIsCogsOnline = flow(function* (this: CogsStore, loanId: any) {
    try {
      this.isCogsLoading = true;
      const response = yield this.cogsService.getIsCogsOnline(loanId);
      this.isCogsOnline = response?.data?.data ?? false;
    } catch (err) {
      // console.error("Error fetching COGS status:", err);
    } finally {
      this.isCogsLoading = false;
    }
  })
}